import userImg from './imgs/current_user.png';
import logoImg from './imgs/logo.png';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcHeader',
  props: {
    //  菜单部分配置
    menu: {
      type: Object,
      default: () => {},
    },
    // logo的配置
    logo: {
      type: Object,
      default: () => {
        return { src: logoImg, title: '泛创通信', height: 32 };
      },
    },
    user: {
      type: Object,
      default: () => {
        return {
          src: userImg,
          avatar: userImg,
          title: '测试用户',
          role: '测试角色',
          toolbar: [],
        };
      },
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      dropDownShow: false,
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    logout() {
      this.$emit('logout');
    },
    changeStatus(val) {
      this.dropDownShow = val;
    },
  },
  render() {
    const { menu, logo, $slots, user, _props, dropDownShow } = this;
    const { style } = _props;
    const { getPrefixCls, locale } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-header');

    return (
      <div class={prefixCls}>
        <div class={`${prefixCls}-logo`}>
          <div class={`${prefixCls}-logo-img`}>
            {logo.src ? (
              <img src={logo.src} style={`height:${logo.height}px`} />
            ) : (
              <img src={logoImg} style="height:32px" />
            )}
          </div>
          <span>{logo.title}</span>
        </div>

        <div class={`${prefixCls}-menu`}>
          {/* 菜单内容，可不传 */}
          {menu ? (
            <a-menu
              {...{ props: menu.props }}
              {...{ on: menu.on }}
              {...{ scopedSlots: menu.scopedSlots }}
            >
              {menu.props.menu.map((item, index) => {
                if ((item.children&&item.children.length === 0)||!item.children) {
                  return (
                    <a-menu-item key={item.key} {...{ props: item.props }}>
                      {/* <fc-icon className={item.icon}></fc-icon> */}
                      <span>{item.name}</span>
                    </a-menu-item>
                  );
                } else {
                  return (
                    <a-sub-menu key={item.key} {...{ props: item.props }} {...{ on: item.on }}>
                      <span slot="title">
                        {/* <fc-icon className={item.icon}></fc-icon> */}
                        <span>{item.name}</span>
                      </span>
                      {item.children.map((el, index) => (
                        <a-menu-item key={el.key} {...{ props: el.props }}>
                          {el.name}
                        </a-menu-item>
                      ))}
                    </a-sub-menu>
                  );
                }
              })}
            </a-menu>
          ) : null}
        </div>
        {/* 操作栏 */}
        <div class={`${prefixCls}-operation`}>{$slots.toolbar}</div>
        {/* 个人中心 */}
        <div class={`${prefixCls}-person`}>
          <a-dropdown placement="bottomRight" onVisibleChange={this.changeStatus}>
            <span class={`${prefixCls}-dropdown-link`} onClick="e => e.preventDefault()">
              {user.src ? <img width="22" src={user.src} /> : <img width="22" src={userImg} />}
              <span class={`${prefixCls}-userImg`}>{this.user.title}</span>
              <fc-icon
                className={dropDownShow ? 'FCxiangshang dropDownUp' : 'FCxiangxia dropDownDown'}
              ></fc-icon>
            </span>
            <a-menu slot="overlay" class={`${prefixCls}-person-user-menu`}>
              <a-menu-item class={`${prefixCls}-person-user-menu-item`}>
                <span class={`${prefixCls}-person-user`}>
                  {/* 头像 */}
                  {user.avatar ? (
                    <img width="42" src={user.avatar} />
                  ) : (
                    <img width="42" src={userImg} />
                  )}
                  <div class={`${prefixCls}-header-person-info`}>
                    <div class={`${prefixCls}-header-person-info-title`}>{this.user.title}</div>
                    <div class={`${prefixCls}-header-person-info-role`}>{this.user.role}</div>
                  </div>
                </span>
              </a-menu-item>
              <a-menu-divider class={`${prefixCls}-dropdown-divider`} />
              {user.toolbar
                ? user.toolbar.map((item, index) => {
                    return (
                      <a-menu-item onClick={item.click} class={`${prefixCls}-toolbar-item`}>
                        {item.icon ? (
                          <fc-icon color="#4E5969" className={`${item.icon} ${prefixCls}-dropdown-icon`}></fc-icon>
                        ) : null}
                        <span>{item.name}</span>
                      </a-menu-item>
                    );
                  })
                : null}
              {user.toolbar && user.toolbar.length > 0 &&   <a-menu-divider class={`${prefixCls}-dropdown-divider`} />}
              <a-menu-item class={`${prefixCls}-toolbar-item`}>
                <fc-icon color="#4E5969" className={`FCtuichu ${prefixCls}-dropdown-icon`}></fc-icon>
                <a href="javascript:;" onClick={this.logout}>
                  {locale.PageHeader.loginOut}
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
    );
  },
};
